import { factory } from "../../../../utils/apiThunkFactory";

export const getBackgrounds = factory.get("settingsModal/getBackgrounds", "/api/users/background/:id");

export const uploadBackground = factory.post("settingsModal/uploadBackground", "/api/users/background");

export const getDefaultBackgrounds = factory.get("settingsModal/getDefaultBackgrounds", "/api/default/background");
export const uploadDefaultBackground = factory.post("settingsModal/uploadDefaultBackground", "/api/default/background");
export const deleteDefaultBackground = factory.delete("settingsModal/deleteDefaultBackground", "/api/default/background/:id");

export const deleteBackground = factory.delete("settingsModal/deleteBackground", "/api/users/background/:id");